class Bug {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.bugId = data.bugId || `BUG${Date.now()}`;
      this.title = data.title || '';
      this.description = data.description || '';
      this.projectId = data.projectId || null;
      this.taskId = data.taskId || null;
      this.reportedBy = data.reportedBy || null;
      this.assignedTo = data.assignedTo || null;
      this.status = data.status || 'Open';
      this.severity = data.severity || 'Medium';
      this.priority = data.priority || 'Medium';
      this.environment = data.environment || '';
      this.stepsToReproduce = data.stepsToReproduce || '';
      this.expectedBehavior = data.expectedBehavior || '';
      this.actualBehavior = data.actualBehavior || '';
      this.attachments = data.attachments || [];
      this.resolvedDate = data.resolvedDate || null;
      this.createdAt = data.createdAt || new Date().toISOString();
      this.updatedAt = data.updatedAt || new Date().toISOString();
    }
  
    getStatusColor() {
      const colors = {
        'Open': '#3b82f6',
        'In Progress': '#f59e0b',
        'Resolved': '#10b981',
        'Closed': '#64748b',
        'Reopened': '#ef4444'
      };
      return colors[this.status] || '#6b7280';
    }
  
    getSeverityColor() {
      const colors = {
        'Critical': '#dc2626',
        'High': '#f59e0b',
        'Medium': '#3b82f6',
        'Low': '#10b981'
      };
      return colors[this.severity] || '#6b7280';
    }
  
    getPriorityColor() {
      const colors = {
        'Critical': '#dc2626',
        'High': '#f59e0b',
        'Medium': '#3b82f6',
        'Low': '#10b981'
      };
      return colors[this.priority] || '#6b7280';
    }
  
    isOpen() {
      return this.status === 'Open' || this.status === 'Reopened';
    }
  
    isResolved() {
      return this.status === 'Resolved' || this.status === 'Closed';
    }
  
    isCritical() {
      return this.severity === 'Critical' || this.priority === 'Critical';
    }
  
    validate() {
      const errors = [];
      
      if (!this.title?.trim()) {
        errors.push('Bug title required');
      }
      
      if (!this.description?.trim()) {
        errors.push('Description required');
      }
      
      if (!this.projectId) {
        errors.push('Project required');
      }
      
      return { 
        isValid: errors.length === 0, 
        errors 
      };
    }
  
    toJSON() {
      return {
        id: this.id,
        _id: this._id,
        bugId: this.bugId,
        title: this.title,
        description: this.description,
        projectId: this.projectId,
        taskId: this.taskId,
        reportedBy: this.reportedBy,
        assignedTo: this.assignedTo,
        status: this.status,
        severity: this.severity,
        priority: this.priority,
        environment: this.environment,
        stepsToReproduce: this.stepsToReproduce,
        expectedBehavior: this.expectedBehavior,
        actualBehavior: this.actualBehavior,
        attachments: this.attachments,
        resolvedDate: this.resolvedDate,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt
      };
    }
  
    static fromJSON(json) {
      return new Bug(json);
    }
  }
  
  export default Bug;